export enum ClientErrors {
  SocialAuthCancelledErrorCode = 'FE_0001'
}